export class AdyenTerminalInfo {
  constructor(public readonly deviceModel: string, public readonly serialNumber: string) {}
}
